export class StreckenTarifierungRequestEvents {
  static readonly PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_VWG = 'PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_VWG';
  static readonly PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_VWG = 'PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_VWG';
  static readonly PREISE_REQUESTED_FAILED_VWG = 'PREISE_REQUESTED_FAILED_VWG';

  static readonly PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_VWG_V2 = 'PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_VWG_V2';
  static readonly PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_VWG_V2 = 'PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_VWG_V2';
  static readonly PREISE_REQUESTED_FAILED_VWG_V2 = 'PREISE_REQUESTED_FAILED_VWG_V2';

  static readonly PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_VHV = 'PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_VHV';
  static readonly PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_VHV = 'PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_VHV';
  static readonly PREISE_REQUESTED_FAILED_VHV = 'PREISE_REQUESTED_FAILED_VHV';

  static readonly PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_VHV_V2 = 'PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_VHV_V2';
  static readonly PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_VHV_V2 = 'PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_VHV_V2';
  static readonly PREISE_REQUESTED_FAILED_VHV_V2 = 'PREISE_REQUESTED_FAILED_VHV_V2';

  static readonly PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_PH = 'PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_PH';
  static readonly PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_PH = 'PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_PH';
  static readonly PREISE_REQUESTED_FAILED_PH = 'PREISE_REQUESTED_FAILED_PH';

  static readonly PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_RS = 'PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_RS';
  static readonly PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_RS = 'PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_RS';
  static readonly PREISE_REQUESTED_FAILED_RS = 'PREISE_REQUESTED_FAILED_RS';

  static readonly PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_RS_VERMIETER =
    'PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_RS_VERMIETER';
  static readonly PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_RS_VERMIETER =
    'PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_RS_VERMIETER';
  static readonly PREISE_REQUESTED_FAILED_RS_VERMIETER = 'PREISE_REQUESTED_FAILED_RS_VERMIETER';

  static readonly PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_THH_HUND =
    'PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_THH_HUND';
  static readonly PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_THH_HUND =
    'PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_THH_HUND';
  static readonly PREISE_REQUESTED_FAILED_THH_HUND = 'PREISE_REQUESTED_FAILED_THH_HUND';

  static readonly PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_THH_PFERD =
    'PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_THH_PFERD';
  static readonly PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_THH_PFERD =
    'PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_THH_PFERD';
  static readonly PREISE_REQUESTED_FAILED_THH_PFERD = 'PREISE_REQUESTED_FAILED_THH_PFERD';

  static readonly PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_TKV = 'PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_TKV';
  static readonly PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_TKV = 'PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_TKV';
  static readonly PREISE_REQUESTED_FAILED_TKV = 'PREISE_REQUESTED_FAILED_TKV';

  static readonly PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_TKV_V2 =
    'PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_TKV_V2';
  static readonly PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_TKV_V2 =
    'PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_TKV_V2';
  static readonly PREISE_REQUESTED_FAILED_TKV_V2 = 'PREISE_REQUESTED_FAILED_TKV_V2';

  static readonly PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_UNF = 'PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_UNF';
  static readonly PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_UNF = 'PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_UNF';
  static readonly PREISE_REQUESTED_FAILED_UNF = 'PREISE_REQUESTED_FAILED_UNF';

  static readonly PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_JHP = 'PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_JHP';
  static readonly PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_JHP = 'PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_JHP';
  static readonly PREISE_REQUESTED_FAILED_JHP = 'PREISE_REQUESTED_FAILED_JHP';

  static readonly PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_GEGE = 'PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_GEGE';
  static readonly PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_GEGE = 'PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_GEGE';
  static readonly PREISE_REQUESTED_FAILED_GEGE = 'PREISE_REQUESTED_FAILED_GEGE';
}
